// extracted by mini-css-extract-plugin
export default {"container":"GeneralGradingPeriodsSection__container___DjxZV","gridWrapper":"GeneralGradingPeriodsSection__gridWrapper___b_qHs"};